import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { verifyInvitation, TerminateInheritanceInvitation } from '../../api/api'

export default function InheritanceTerminatePage() {


    const { terminateString } = useParams();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [validToken, setValidToken] = useState(false);
    const [tokenLoader, setTokenLoader] = useState(false);


    useEffect(() => {

        verifyInviteToken(terminateString);

    }, []);


    const verifyInviteToken = async (terminateString) => {

        try {
            const { status, message } = await verifyInvitation(terminateString);
            console.log('verifyInviteToken API Response:', status, message);
            if (status) {
                setValidToken(true);
                setTimeout(() => {
                    setTokenLoader(true);
                }, 2000);
            } else {
                setErrorMessage(message || 'Invalid token.');
            }
        } catch (error) {
            console.error('verifyInviteToken Error:', error);
            setErrorMessage(error.message || 'Something went wrong.');
        }
    };


    const handleTerminateSubmit = async () => {
        try {
            const { status, message } = await TerminateInheritanceInvitation(terminateString)
            console.log('handleTerminateSubmit response', status, message)
            if (status) {
                messageShowHandler("Inheritance process Terminate successfully");
            }
        } catch (error) {
            console.log('handleTerminateSubmit', error)
        }
    }

    const messageShowHandler = (msgText) => {
        navigate("/response", { state: msgText });
    }


    return (
        <div className='landingPage'>
            {
                !tokenLoader &&
                <div className="loaderContainer">
                    {validToken ? (
                        <h2>Link Verified Successfully</h2>
                    ) : errorMessage ? (
                        <h2 className="error">{errorMessage}</h2>
                    ) : (
                        <span className="loaderAnimation">Loading...</span>
                    )}
                </div>
            }

            <div className='landingContentPart'>
                <h3 className='headingtext'>
                    Terminate Inheritance appeal.
                </h3>
                <p className='paraText'>
                    This termination process involves deleting your current inheritance role, requiring you to add a new inheritance role.
                    If you wish to terminate the process, simply  click the 'Terminate' button. This will cancel the recovery key process.
                </p>
                <div className='btnWrapper'>
                    <button className='cancelBtn' onClick={handleTerminateSubmit}>Terminate</button>
                </div>
            </div>
        </div>
    )
}
